var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/ExcalidrawExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/excalidraw/client/x-excalidraw.js";
import "@adornis/excalidraw/db/ExcalidrawData.js";
import "@adornis/fonts/fonts.js";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseExcalidraw } from "../../db/extensions/BaseExcalidraw.js";
import { ContainerExtension, XContainerExtension } from "./ContainerExtension.js";
var ExcalidrawExtension = {
  class: BaseExcalidraw,
  toolbar: { icon: "polyline", text: { default: "Excalidraw" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-excalidraw-extension
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-excalidraw-extension>
    `;
  },
  editor(options) {
    return html`
      ${ContainerExtension.editor?.(options) ?? nothing}
      <x-flex space="sm">
        <x-input placeholder="Höhe" ${options.contentController?.field("height")}></x-input>
      </x-flex>
    `;
  },
  group: "Sonstige"
};
var XExcalidrawExtension = class extends XContainerExtension {
  _content(content) {
    const mode = this._consumedMode.value;
    const height = content.height || "500px";
    return html`
      <x-excalidraw
        ${css({
      width: "100%",
      height,
      boxSizing: "border-box"
    })}
        .mode=${mode}
        .height=${height}
        .value=${content.data}
        @value-changed=${(e) => {
      if (!this.content.value)
        return;
      this.content.value.data = e.detail.value;
    }}
      ></x-excalidraw>
    `;
  }
};
XExcalidrawExtension = __decorateClass([
  customElement("x-excalidraw-extension")
], XExcalidrawExtension);
export {
  ExcalidrawExtension,
  XExcalidrawExtension
};
